module.exports = "## Image optimization for webmasters\r\n\r\nIf you are a webmaster, you want your pages to load faster to provide the best user experience. Optimizing your images will lead to faster page loading, save bandwidth, and help your website rank higher in search results."


//////////////////
// WEBPACK FOOTER
// ./src/containers/CompressImages/image-optimization.md
// module id = 1141
// module chunks = 0